import * as actionTypes from "../../actionLabels/bankUpdateDetail/bankUpdateDetail";

export const getUserWiseBankDetails = () => {
  return {
    type: actionTypes.GET_USER_WISE_BANK_DETAILS,
  };
};

export const getUserWiseBankDetailsSuccess = (data) => {
  return {
    type: actionTypes.GET_USER_WISE_BANK_DETAILS_SUCCESS,
    payload: data,
  };
};

export const getUserWiseBankDetailsFail = (error) => {
  return {
    type: actionTypes.GET_USER_WISE_BANK_DETAILS_FAIL,
    payload: error,
  };
};
